export default __webpack_public_path__ + "static/noah:lidiah-2b975b07298ee05e7be03b1b7ade474f.png";